<div class="join-dialog flex flex-row flex-start-stretch gap-60">
  <div class="ai-skills-update-dialog-image-content flex-initial hidden md:flex" data-test-id="ai-skills-update-image-content">
    <img alt="map" src="assets/images/dialogs/skills-update-bg.svg" />
  </div>
  <div class="ai-skills-update-dialog-content flex flex-col flex-full flex-start-between">
    <h4 data-test-id="ai-skills-update-dialog-content-title" mat-dialog-title>
      Got AI skills? Let’s add them to your 7N CV!
      <button
        (click)="closeDialog()"
        class="close-btn ai-skills-update-dialog-content-button"
        data-test-id="ai-skills-update-dialog-content-button"
        isIconButton="true"
        mat-button
      >
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </h4>
    <form
      (ngSubmit)="onSubmit()"
      class="flex flex-col w-full h-full flex-full"
      data-test-id="ai-skills-update-form"
      novalidate
    >
      <div class="flex flex-col flex-start-stretch gap-24 newsletter-dialog-content-text" data-test-id="newsletter-dialog-content-text" mat-dialog-content>
        <p>
          The demand for AI expertise is skyrocketing. At 7N, we want you at the forefront of this shift. Don’t let your expertise go unnoticed - make your AI skills searchable for our clients today.
        </p>
        <p>
          Take a moment to update your resume on my7N. Why? This allows us to offer you more interesting projects that perfectly reflect your current experience and knowledge.
        </p>
        <div>
          <p>
            What to include?
          </p>
          <ul>
            <li>Skills & Roles: Update your AI-related competencies and roles,</li>
            <li>CV Summary: Add a brief block explaining your AI approach (what tools you use and how they make you more effective),</li>
            <li>Growth: List any AI courses, conferences, or webinars you’ve attended.</li>
          </ul>
        </div>
      </div>
      <div class="flex flex-end-center" mat-dialog-actions>
        <button
          [loading]="loading"
          class="small-button"
          color="primary"
          data-test-id="ai-skills-update-form-send-button"
          mat-flat-button
          type="submit"
        >
          Boost your CV
        </button>
        <button
          (click)="closeDialog()"
          class="small-button"
          color="primary"
          data-test-id="ai-skills-update-form-cancel-button"
          mat-button
          type="button"
        >
          Close
        </button>
      </div>
    </form>
  </div>
</div>
